import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import Navbar from '../navcomun';
import servicio1 from '../../../services/servicio1';
import fondoCancha from '../../../Assets/fondo-cancha.jpg';

export default function SolicitudesPage() {
  const [solicitudes, setSolicitudes] = useState([]);
  const [solicitudesDirectas, setSolicitudesDirectas] = useState([]);
  const [user, setUser] = useState(null);
  const [cargando, setCargando] = useState(true);

  const [modalAbierto, setModalAbierto] = useState(false);
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);

  const fetchSolicitudes = async () => {
    const loggedUserJSON = window.localStorage.getItem('loggedNoteAppUser');
    if (loggedUserJSON) {
      const userData = JSON.parse(loggedUserJSON);
      setUser(userData);
      try {
        const data = await servicio1.traersolicitudes({ id: userData.id });
        setSolicitudes(data[0] || []);
        setSolicitudesDirectas(data[1] || []);
      } catch (error) {
        console.error('Error al traer solicitudes', error);
      }
    }
    setCargando(false);
  };

  useEffect(() => {
    fetchSolicitudes();
  }, []);

  const cancelarConvocatoriaDirecta = async (idConvocatoria) => {
    try {
      await servicio1.cancelarConvocatoriaDirecta({ id: idConvocatoria });
      await fetchSolicitudes();
    } catch (error) {
      console.error('Error al cancelar convocatoria directa:', error);
      alert('No se pudo cancelar la solicitud.');
    }
  };

  const responderSolicitud = async (respuesta) => {
    try {
      await servicio1.responderconvocatoriadirecta({
        id: solicitudSeleccionada.id,
        respuesta: respuesta, // 'aceptar' o 'rechazar'
      });
      setModalAbierto(false);
      await fetchSolicitudes();
    } catch (error) {
      console.error('Error al responder solicitud:', error);
      alert('Hubo un problema al enviar la respuesta.');
    }
  };

  const abrirModal = (solicitud) => {
    setSolicitudSeleccionada(solicitud);
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setSolicitudSeleccionada(null);
  };

  const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return 'Edad no disponible';
    const [dia, mes, anio] = fechaNacimiento.split('/');
    const nacimiento = new Date(`${anio}-${mes}-${dia}`);
    const hoy = new Date();
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    if (
      hoy.getMonth() < nacimiento.getMonth() ||
      (hoy.getMonth() === nacimiento.getMonth() && hoy.getDate() < nacimiento.getDate())
    ) {
      edad--;
    }
    return edad;
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${fondoCancha})`,
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        pb: 4,
      }}
    >
      <Navbar />

      <Box sx={{ p: 2, backgroundColor: 'rgba(255,255,255,0.85)', m: 2, borderRadius: 3 }}>
        <Typography
          variant="h5"
          sx={{
            mb: 3,
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#1b5e20',
            textShadow: '1px 1px 0px white',
          }}
        >
          ⚽ Solicitudes de Jugadores
        </Typography>

        {cargando ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress color="success" />
          </Box>
        ) : solicitudes.length === 0 ? (
          <Typography align="center" sx={{ color: '#2e7d32', fontWeight: 'bold' }}>
            🕊️ No tenés solicitudes en este momento.
          </Typography>
        ) : (
          solicitudes.map((solicitud) => (
            <Box
              key={`normal-${solicitud.id}`}
              sx={{
                border: '2px dashed #1b5e20',
                backgroundColor: '#f1f8e9',
                borderRadius: 2,
                p: 2,
                mb: 3,
                boxShadow: '2px 2px 10px rgba(0,0,0,0.2)',
              }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                👤 Representante: {solicitud.nombre}
              </Typography>
              <Typography variant="body2">
                🧑 Jugador: <b>{solicitud.nombresol}</b> ({solicitud.apodo})
              </Typography>
              <Typography variant="body2">
                🥅 Posición: <b>{solicitud.posicion}</b>
              </Typography>
              <Typography variant="body2">
                📆 Edad: <b>{calcularEdad(solicitud.fecha_nacimiento)}</b> años
              </Typography>
              <Typography variant="body2">
                ⏳ Estado: <b>{solicitud.estado}</b>
              </Typography>
            </Box>
          ))
        )}

        {solicitudesDirectas.length > 0 && (
          <>
            <Typography
              variant="h6"
              sx={{
                mt: 4,
                mb: 2,
                fontWeight: 'bold',
                textAlign: 'center',
                color: '#1565c0',
              }}
            >
              📩 Solicitudes Directas ({solicitudesDirectas.length})
            </Typography>

            {solicitudesDirectas.map((solicitud) => (
              <Box
                key={`directa-${solicitud.id}`}
                sx={{
                  border: '2px dashed #0d47a1',
                  backgroundColor: '#e3f2fd',
                  borderRadius: 2,
                  p: 2,
                  mb: 3,
                  boxShadow: '2px 2px 10px rgba(0,0,0,0.2)',
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  👤 Nombre convocado: {solicitud.nombreconvocado} - {solicitud.apodo}
                </Typography>
                <Typography variant="body2">
                  ⏳ Estado: <b>{solicitud.estado}</b> <br />
                  Fecha: <b>{solicitud.fecha}</b><br />
                  Hora:  <b>{solicitud.hora}</b>
                </Typography>
                {(() => {
                  if (solicitud.estado === 'convocado') {
                    return (
                      <>
                        <Typography
                          variant="body2"
                          sx={{ fontWeight: 'bold', color: '#f57c00', mt: 1 }}
                        >
                          📨 Solicitud recibida
                        </Typography>
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{ mt: 2 }}
                          onClick={() => abrirModal(solicitud)}
                        >
                          📬 Responder solicitud
                        </Button>
                      </>
                    );
                  }

                  if (solicitud.estado === 'Aceptado') {
                    return (
                      <>
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 'bold',
                            color: 'green',
                            mt: 1,
                            backgroundColor: '#dcedc8',
                            px: 1.5,
                            py: 0.5,
                            borderRadius: 1,
                            display: 'inline-block',
                          }}
                        >
                          ✅ Solicitud confirmada
                        </Typography>
                        <Button
                          variant="outlined"
                          color="error"
                          sx={{ mt: 2 }}
                          onClick={() => {
                            const confirmar = window.confirm('¿Querés cancelar esta confirmación?');
                            if (confirmar) cancelarConvocatoriaDirecta(solicitud.id);
                          }}
                        >
                          ❌ Cancelar / Arrepentirse
                        </Button>
                      </>
                    );
                  }

                  if (solicitud.estado === 'Rechazado') {
                    return (
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 'bold', color: 'gray', mt: 1 }}
                      >
                        ❌ Rechazado
                      </Typography>
                    );
                  }

                  return null;
                })()}

              </Box>
            ))}
          </>
        )}
      </Box>

      {/* Modal para aceptar o rechazar */}
      <Dialog open={modalAbierto} onClose={cerrarModal}>
        <DialogTitle>Responder solicitud</DialogTitle>
        <DialogContent>
          {solicitudSeleccionada && (
            <>
              <Typography>
                ¿Querés aceptar la solicitud de <b>{solicitudSeleccionada.nombreconvocado}</b>?
              </Typography>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => responderSolicitud('rechazar')} color="error">
            Rechazar
          </Button>
          <Button onClick={() => responderSolicitud('aceptar')} color="success">
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
